import { SessionProviderEnum } from 'graphql/types.generated'
import { useFirebase } from 'hooks/firebase/useFirebase'
import { useSessionStorage } from 'hooks/useStorage'
import { useCallback } from 'react'

const LOCAL_STORAGE_LOGIN_ANALYTICS_KEY = 'LOGGED_SESSION_PROVIDER_INTO_ANALYTICS'

export function useLoginAnalytics() {
  const { analytics } = useFirebase()
  const [isLoggedIntoAnalytics, setLoggedIntoAnalytics, remove] = useSessionStorage(LOCAL_STORAGE_LOGIN_ANALYTICS_KEY)

  const log = useCallback(
    (sessionProvider: SessionProviderEnum) => {
      if (!isLoggedIntoAnalytics() && sessionProvider) {
        analytics.logEvent(`logar_via_${sessionProvider}`)
        setLoggedIntoAnalytics(true)
      }
    },
    [analytics, isLoggedIntoAnalytics, setLoggedIntoAnalytics]
  )

  return {
    log,
    remove,
  }
}
